var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.521 42.423c.011 1.671-1.412 3.03-3.057 3.07H9.457a5.064 5.064 0 0 0 .037-6.098h15.977a3.05 3.05 0 0 1 3.05 3.028",
    fill: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.377 43.34a3.05 3.05 0 0 0-2.907-2.126H10.346a5.1 5.1 0 0 0-.854-1.82h15.993c2.07.012 3.516 2.047 2.892 3.947",
    fill: "url(#paint0_linear_9129_61363)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.387 47.18h17.997a4.736 4.736 0 0 0 0-9.471H25.471a4.736 4.736 0 0 1 4.735 4.736c0 2.617-2.204 4.735-4.82 4.735",
    fill: "#A9AFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M43.384 47.181H25.387a4.87 4.87 0 0 0 3.886-1.952h14.11a4.74 4.74 0 0 0 4.634-3.76 4.74 4.74 0 0 1-4.633 5.712",
    fill: "url(#paint1_linear_9129_61363)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.384 47.508H25.387v-.656c2.476 0 4.49-1.977 4.49-4.407a4.405 4.405 0 0 0-4.406-4.408v-.656h17.913a5.064 5.064 0 0 1 0 10.127m-15.465-.656h15.465a4.408 4.408 0 0 0 0-8.815H27.968a5.048 5.048 0 0 1-.05 8.815",
    fill: "#5E6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.206 42.412c.017 2.624-2.198 4.768-4.82 4.768H7.437a.842.842 0 1 1 0-1.68h17.947c1.68 0 3.147-1.377 3.135-3.072a3.05 3.05 0 0 0-3.05-3.029H7.438a.843.843 0 0 1 0-1.685H25.47a4.74 4.74 0 0 1 4.736 4.697",
    fill: "#A9AFC4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.206 42.412c.017 2.624-2.198 4.768-4.82 4.768H7.437a.842.842 0 1 1 0-1.68h17.947c1.68 0 3.147-1.377 3.135-3.072a3.05 3.05 0 0 0-3.05-3.029H7.438a.843.843 0 0 1 0-1.685H25.47a4.74 4.74 0 0 1 4.736 4.697",
    fill: "url(#paint2_linear_9129_61363)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.385 47.508H7.436a1.17 1.17 0 1 1 0-2.336h17.947c1.494 0 2.818-1.225 2.807-2.742a2.723 2.723 0 0 0-2.722-2.703H7.437a1.172 1.172 0 0 1 0-2.341H25.47a5.064 5.064 0 0 1 5.064 5.031c0 2.925-2.455 5.091-5.149 5.091m-17.948-1.68a.514.514 0 0 0 0 1.028h17.947c2.421 0 4.509-1.977 4.493-4.438a4.407 4.407 0 0 0-4.408-4.375H7.437a.515.515 0 0 0 0 1.03H25.47a3.38 3.38 0 0 1 3.378 3.353c.013 1.898-1.623 3.404-3.463 3.404z",
    fill: "#5E6175"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.506 43.37H33.421a1.077 1.077 0 1 1 0-2.155h11.085a1.077 1.077 0 1 1 0 2.154",
    fill: "#EEF0F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 40.887h13.115v.656H10.41zm8.395 2.154h9.488v.656h-9.488z",
    fill: "#5E6175"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m8.793 45.82.4-.526a4.73 4.73 0 0 0 .034-5.7l-.386-.524h16.643a3.376 3.376 0 0 1 3.363 3.354c0 1.906-1.597 3.358-3.376 3.401zm1.279-.655h15.39a2.86 2.86 0 0 0 1.936-.846c1.728-1.741.43-4.585-1.917-4.594H10.098a5.39 5.39 0 0 1-.026 5.44",
    fill: "#5E6175"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.598 28.797h20.25a3.454 3.454 0 0 1 0 6.907h-20.25z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M38.172 33.175a3.45 3.45 0 0 0-3.328-2.53H14.598v-1.848h20.248a3.454 3.454 0 0 1 3.326 4.378",
    fill: "url(#paint3_linear_9129_61363)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.098 35.705h21.748a3.454 3.454 0 0 0 0-6.907H13.098v-1.98h21.875a5.447 5.447 0 0 1 2.107 10.5 5.5 5.5 0 0 1-2.107.391H13.098z",
    fill: "#DEE1EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.847 36.032H14.27v-7.563h20.577a3.782 3.782 0 0 1 0 7.563m-19.921-.656h19.921a3.126 3.126 0 0 0 0-6.251H14.926z",
    fill: "#5E6175"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.973 38.038H12.77v-2.662h22.077a3.126 3.126 0 0 0 0-6.25H12.77V26.49h22.203a5.775 5.775 0 1 1 0 11.547zm-21.547-.657h21.547a5.117 5.117 0 1 0 0-10.234H13.426v1.322h21.42a3.782 3.782 0 0 1 0 7.564h-21.42z",
    fill: "#5E6175"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.598 33.243h12.71v.656h-12.71zm17.754-2.073h5.864v.656h-5.864zm-17.754 0h4.39v.656h-4.39z",
    fill: "#5E6175"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.313 13.479a4.49 4.49 0 0 0-4.183-.34c-2.021.881-4.11 2.81-4.11 6.395 0 3.073 1.354 4.93 2.636 5.998a5.6 5.6 0 0 0 3.585 1.286h4.148a5.54 5.54 0 0 0 3.472-1.195c1.312-1.053 2.746-2.928 2.746-6.09 0-3.584-2.088-5.513-4.11-6.394a4.48 4.48 0 0 0-4.184.34",
    fill: "#2C9424"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.39 27.146h-4.15a5.93 5.93 0 0 1-3.794-1.361c-1.257-1.048-2.755-2.983-2.755-6.251 0-4.193 2.7-5.995 4.309-6.696a4.8 4.8 0 0 1 4.313.257 4.8 4.8 0 0 1 4.315-.257c1.608.7 4.307 2.503 4.307 6.696 0 3.341-1.56 5.295-2.868 6.344a5.9 5.9 0 0 1-3.678 1.268M23.263 13.44c-1.46.638-3.913 2.277-3.913 6.095 0 3.014 1.37 4.788 2.516 5.746a5.27 5.27 0 0 0 3.375 1.21h4.148a5.23 5.23 0 0 0 3.267-1.123c1.197-.96 2.626-2.752 2.626-5.833 0-3.818-2.453-5.457-3.914-6.095a4.15 4.15 0 0 0-3.876.316l-.176.11-.175-.11a4.16 4.16 0 0 0-3.88-.316z",
    fill: "#5E6175"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.64 13.479h-.656v-1.245a7.46 7.46 0 0 1 2.2-5.311l.465.464a6.8 6.8 0 0 0-2.008 4.847z",
    fill: "#5E6175"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.29 6.983h-1.352v1.353a3.024 3.024 0 0 0 3.023 3.024h1.353v-1.353a3.023 3.023 0 0 0-3.023-3.024",
    fill: "#DEE1EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.642 11.688H25.96a3.355 3.355 0 0 1-3.352-3.352v-1.68h1.681a3.356 3.356 0 0 1 3.352 3.35zm-4.375-4.375v1.024a2.697 2.697 0 0 0 2.695 2.696h1.025v-1.026a2.7 2.7 0 0 0-2.695-2.695z",
    fill: "#5E6175"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m24.563 9.148.463-.464 2.481 2.481-.464.464zM3.938 46.853h45.496v.656H3.938zm9.953-22.9a1.272 1.272 0 0 1 0-2.543c0 .74 0 0 .007 0a1.272 1.272 0 1 1-.007 2.543m-.614-1.27a.615.615 0 1 0 1.047-.437.616.616 0 0 0-1.043.432zm-4.201 5.711a.985.985 0 1 1-.004-1.97.985.985 0 0 1 .004 1.97m0-1.313a.328.328 0 0 0-.228.559.33.33 0 0 0 .231.095.328.328 0 0 0 .122-.63.3.3 0 0 0-.125-.022zM48.39 37.473l1.565-1.565.464.464-1.564 1.565zm-1.913-3.143h.656v2.213h-.656zm3.375 4.736h2.212v.657h-2.212z",
    fill: "#5E6175"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m4.795 38.127-.639-.139q.076-.353.219-.685l.602.263q-.119.271-.182.561m.719-1.384-.485-.437q.243-.268.535-.481l.388.528a3 3 0 0 0-.438.39m1.312-.839-.197-.626q.346-.108.705-.147l.07.657q-.294.03-.577.117m4.047-.138h-.656v-.657h.656zm-1.75 0h-.656v-.657h.656z",
    fill: "#A9AFC4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9129_61363",
    x1: 19.008,
    y1: 38.344,
    x2: 19.008,
    y2: 47.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9129_61363",
    x1: 25.387,
    y1: 44.325,
    x2: 48.121,
    y2: 44.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9129_61363",
    x1: 18.402,
    y1: 37.434,
    x2: 18.402,
    y2: 50.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9129_61363",
    x1: 26.451,
    y1: 26.402,
    x2: 26.451,
    y2: 40.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.b1a9b56cdc73aadadad2c1826f6d0e59.svg";
export { ForwardRef as ReactComponent };